
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import { Header, Footer } from "./PDFcomponents";

import openSans from '../../../../fonts/OpenSans-Regular.ttf';
import openSansBold from '../../../../fonts/OpenSans-Bold.ttf';
import openSansItalic from '../../../../fonts/OpenSans-Italic.ttf';
import { CustomerState } from '../../../../redux/customer';
import { ChildCustomerState } from '../../../../redux/childCustomer';

Font.register({ family: 'Open Sans', fonts: [{ src: openSans }, { src: openSansBold, fontWeight: 'bold' }, { src: openSansItalic, fontStyle: 'italic' }] });

const COMPLIANCE_BLUE = '#0084b7';
const COMPLIANCE_CRANBERRY = '#9f000f';
const COLORED_ROW = '#e9ecef';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Open Sans',
    fontSize: '10pt'
  },
  checklistSectionHeading: {
    backgroundColor: COMPLIANCE_BLUE,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '20pt',
    padding: '5pt'
  },
  content: {
    margin: '0 0.25in',
    flex: 1
  },
  errorMessage: {
    color: COMPLIANCE_CRANBERRY,
    fontStyle: 'italic'
  },
  table: {
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  tableCol: {
    flex: 1,
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCell: {
    margin: 5
  },
  tableHeader: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '12pt'
  },
  statusCol: {
    flex: 1
  },
  coloredTableRow: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: COLORED_ROW
  },
})

const handleRowColor = (index: number) => {
  return index % 2 === 0
    ? styles.tableRow
    : styles.coloredTableRow
}

type BusinessAssociateColumnKeys = 'id' | 'name' | 'type' | 'address';

interface BusinessAssociatesPDFProps {
  businessAssociates: Record<BusinessAssociateColumnKeys, string>[],
  customer: CustomerState | ChildCustomerState;
  title: string;
  year?: string;
}

const BusinessAssociatesPDF = ({ businessAssociates, customer, title, year }: BusinessAssociatesPDFProps) => {
  if (!title || !year || !customer.customer_number) {
    return;
  }
  return (
    <Document>
      <Page size="A4" orientation="landscape" wrap style={styles.page}>
        <Header customer={customer} title={title} year={year}></Header>
        <View style={styles.content}>
          <View style={styles.checklistSectionHeading}>
            <Text>Business Associates List</Text>
          </View>
          {businessAssociates.length > 0 ? (
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCol, styles.tableHeader, styles.statusCol]}>
                  <Text style={styles.tableCell}>Name of Business Associate</Text>
                </View>
                <View style={[styles.tableCol, styles.tableHeader]}>
                  <Text style={styles.tableCell}>Type of Business Associate</Text>
                </View>
                <View style={[styles.tableCol, styles.tableHeader]}>
                  <Text style={styles.tableCell}>Address</Text>
                </View>
              </View>
              {businessAssociates.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0).map(({ id, name, type, address }, i) => {
                return (
                  <View key={id} style={handleRowColor(i)}>
                    <View style={[styles.tableCol, styles.statusCol]}>
                      <View style={styles.tableCell}>
                        <Text>{name}</Text>
                      </View>
                    </View>
                    <View style={[styles.tableCol, styles.statusCol]}>
                      <View style={styles.tableCell}>
                        <Text>{type}</Text>
                      </View>
                    </View>
                    <View style={[styles.tableCol, styles.statusCol]}>
                      <View style={styles.tableCell}>
                        <Text>{address}</Text>
                      </View>
                    </View>
                  </View>
                );
              })}
            </View>
          ) :
            (
              <Text style={styles.errorMessage}>No data is available for this section</Text>
            )}
        </View>
        <Footer />
      </Page>
    </Document>
  );
};

export default BusinessAssociatesPDF;